const EPSILON = 1e-4; // Constant to avoid division by zero

export const formatTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, "0")}`;
};

export const getFrameIndexFromTime = (
  time: number,
  duration: number,
  totalFrames: number,
): number => {
  if (totalFrames <= 1 || duration < EPSILON) return 0;
  return Math.round((time / duration) * (totalFrames - 1));
};
